import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { api } from '@src/app/app.const';
import { AppAuthService } from '@src/app/core/services/app-auth.service';
import { PasswordStrengthModel } from '@src/app/shared/components/password-strength/interfaces/index';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss'],
  standalone: false,
})
export class ChangePasswordDialogComponent {
  title: string;
  isEditing: boolean = false;
  passwordPolicies: any;
  passwordStrength: number = 0;

  private _authService = inject(AppAuthService);
  private _dialogRef = inject(MatDialogRef<ChangePasswordDialogComponent>);
  private _data = inject(MAT_DIALOG_DATA);

  passwordStrengthForm = signal<PasswordStrengthModel>({
    confirmPassword: '',
    password: '',
    valid: false,
  });

  constructor() {
    this.passwordPolicies = this._data.passwordPolicies;
  }

  getFormValues(event: PasswordStrengthModel) {
    this.passwordStrengthForm.set(event);
  }

  get api(): any {
    return api.webview;
  }

  async onSave(): Promise<void> {
    const resp = await this._authService.confirmSignIn(this.passwordStrengthForm().password);

    this._dialogRef.close(resp);
  }

  onStrengthChanged(strength: number) {
    this.passwordStrength = strength;
  }

  removeSpaces(event: any) {
    const value = event.target.value.replace(/\s/g, '');
    event.target.value = value;
  }
}
